import React from "react";
import Navbar from "../../component/Navbar";
import Footer from "../../component/Footer";
import { Link } from "react-router-dom";

const Relaxation24 = () => {
  return (
    <div>
      <section className="bg-[#F5F5F5] h-screen shadow-[0_3px_10px_rgb(0,0,0,0.2)] m-4 rounded-md">
        {/* Relaxation start here */}
        <div className=" w-full px-4 shadow-lg rounded-[10px]">
          <div className="inline-block mx-[10px] px-[5px] rounded-[5px] mt-[10px]">
            <h2 className="text-xl font-bold">RELAXATION</h2>
          </div>
          <div>
            <h4 className="mx-[18px] mt-[5px] text-[#2A5801] font-semibold">
              PLEASE CHOOSE ONE
            </h4>
          </div>
          <div className="pt-20 space-y-6">
            <div>
              <Link to="https://www.youtube.com/watch?v=qyfNSzDj_Yg">
                <button className=" text-[#314C1C] font-medium border-2 border-[#314C1C] w-full p-2 rounded-md mb-5">
                  Stretch &amp; Release
                </button>
              </Link>
            </div>
            <div>
              <Link to="../relaxation25">
                <button className=" text-[#314C1C] font-medium border-2 border-[#314C1C] w-full p-2 rounded-md mb-5">
                  Deep Breathing
                </button>
              </Link>
            </div>
            <div>
              <Link to="https://www.youtube.com/shorts/CfM7MJkYSAA">
                <button className="text-[#314C1C] font-medium border-2 border-[#314C1C] w-full p-2 rounded-md mb-5">
                  Mini-Visualization
                </button>
              </Link>
            </div>
            <div>
              <Link to="https://www.youtube.com/watch?v=u5W0QK1tSOM">
                <button className=" text-[#314C1C] font-medium border-2 border-[#314C1C] w-full p-2 rounded-md mb-5">
                  Mini-Meditation
                </button>
              </Link>
            </div>
            <div>
              <Link to="https://www.youtube.com/watch?v=uT6ASPy2Dbs">
                <button className=" w-full   px-4 py-2 border-2 border-[#295700] text-[#295700] text-center text-[#295700 rounded-sm">
                  Positive Affirmations
                </button>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Relaxation24;
